import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getCardsByMonth } from '../../actions/cardsActions'
import MonthPickerInput from 'react-month-picker-input'
import 'react-month-picker-input/dist/react-month-picker-input.css'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'

export default function Invoices() { 
    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [monthReport, setMonthReport] = useState('')
    const [cardsWithImage, setCardsWithImage] = useState('')
    
    const {cards} = useSelector((state) => state.cards)

    useEffect(()=>{
        dispatch(getCardsByMonth(monthReport))
    }, [monthReport, dispatch])

    useEffect(()=>{
        if(cards){
            setCardsWithImage(cards.filter(card => card.image))
        }
    }, [cards])

    const changeMonth = (selectedMonth, selectedYear) => {
        if(selectedMonth+'-'+selectedYear !== '-'){

            if(selectedMonth < 10){
                selectedMonth = '01-0'+selectedMonth
            }else{
                selectedMonth = '01-'+selectedMonth
            }

            setMonthReport(selectedMonth+'-'+selectedYear)
        }
    }
    const columns = [
        {
            name: t('cardaux.date'),
            cell: datos =>
                <div className='form-check checkbox-lg'>
                    {datos?.in?.substr(8,2)+'/'+datos?.in?.substr(5,2)+'/'+datos?.in?.substr(0,4)}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: t('users.Operario'),
            cell: datos =>
                <div className='form-check checkbox-lg'>
                    {datos?.user?.firstname} {datos?.user?.lastname}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: t('cardaux.farm')+'/'+t('cardaux.plot'),
            cell: datos =>
                <div className='form-check checkbox-lg'>
                    {/* {datos?.campaign?.plot?.farm?.name}<br/>
                    {datos?.campaign?.plot?.name}<br/> */}
                    {datos?.plot?.farm?.name}<br/>
                    {datos?.plot?.name}<br/>
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: t('cardaux.labor')+'/'+t('resume.crop'),
            cell: datos =>
                <div className='form-check checkbox-lg'>
                    {datos?.labor?.name}<br/>
                    {/* {datos?.campaign?.crop?.name} */}
                    {datos?.crop?.name}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: <></>,
            cell: datos =>
            <>
                {datos?.image
                ?
                <>
                    <Button variant="outline-warning mx-auto" href={datos?.image} target="_blank" rel="noreferrer">
                        <i className="fas fa-image"></i> <i className="fas fa-eye"></i>
                    </Button>
                </>
                : 
                    <></>
                }
            </>
        }
    ]

    const goBack = () => {
        navigate('/administrative/dashboard')
    }

    return (
        <>
            <Container className='cuerpo'>
                <Row className="text-left custom-card-header">
                    <Row className="custom-card-buttom">
                        <Button className="btn btn-secondary mb-4 mx-auto" onClick={goBack}>
                            <i className="fas fa-arrow-circle-left"></i> {t('global.return')}
                        </Button>
                    </Row>
                    <h1>{t('administrative.managereports')}</h1>
                    <Form.Label className="form-label">{t('administrative.selectactionreport')}</Form.Label>
                    <br/><br/><br/>
                    <Row className="text-center my-3">
                        <Col>
                            <Form.Group className="my-3">
                                <Form.Label>{t('administrative.selectmonth')}</Form.Label>
                                {/* {-------------------------------------------------------------} */}
                                <MonthPickerInput
                                    lang='es'
                                    className='month-calendar'
                                    onChange={function(maskedValue, selectedYear, selectedMonth) {
                                        selectedMonth = selectedMonth+1

                                        changeMonth(selectedMonth++, selectedYear)
                                    }}
                                />
                                {/* {-------------------------------------------------------------} */}
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="text-center justify-content-center">
                        {cardsWithImage && cardsWithImage.length > 0 
                            ?
                                <CustomDataTable columns={columns} data={cardsWithImage} />
                            :
                                <label className="text-warning">* {t('administrative.thereisnotinvoices')} *</label>
                        }
                    </Row>
                </Row>
            </Container>
        </>
    )
}


  
                
